
export const collectionFormStyles = {

    newCollectionFormContainer: {
        display: 'flex',
        justifyContent: 'center',
        // alignItems: 'center',
        alignContent: 'center',
        width: '100%',
        maxWidth: 640,
        margin: '2px auto',
        // bgcolor: '#B6DAFF',        
        minHeight: 460,
        overflow: 'hidden',
        // height: 140,
        // padding: 1,
        boxShadow: '3px 3px 7px 1px #ccc',
        // background: '#B6DAFF',
        // background:'#478ac92b',
        background: '#DAE5F1',
        borderRadius: '10px',
        '& h5': {
            fontWeight: 500,
        },
        '& span': {
            color: '#000',
        },
        '& .MuiDivider-root': {
            backgroundColor: '#f1f1f1'
        },
        '& .MuiInputBase-input': {
            color: '#000'
        },
        '& .MuiFormLabel-root': {
            color: '#000'
        },
        '& .MuiOutlinedInput-root': {
            borderColor: '#000'
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#000'
        },
        "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
            borderColor: "#000"
        },
        // "&:hover": {
        //     borderColor: "#000"
        // },
        '& .MuiSelect-iconOutlined': {
            color: '#000',
            borderColor: "#000"
        },
        '& .MuiFormControl-root': {
            borderWidth: 0,
            borderColor: "#000"
        },
        '& .Mui-disabled': {
            color: '#000',
            borderColor: '#000',
        }
    },
    collectionFormContainer: {
        // padding: 1,
        display: 'flex',
        justifyContent: 'center',
        // alignItems: 'center',
        alignContent: 'center',
        width: '100%',
        maxWidth: 900,
        margin: '2px auto',
        // bgcolor: '#B6DAFF',        
        minHeight: 380,
        overflow: 'hidden',
        // height: 140,
        // padding: 1,
        boxShadow: '3px 3px 7px 1px #ccc',
        // background: '#B6DAFF',
        // background:'#478ac92b',
        background: '#DAE5F1',
        borderRadius: '10px',
        '& h5': {
            fontWeight: 500,
        },
        '& span': {
            color: '#000',
        },
        '& .MuiDivider-root': {
            backgroundColor: '#f1f1f1'
        },
        '& .MuiInputBase-input': {
            color: '#000'
        },
        '& .MuiFormLabel-root': {
            color: '#000'
        },
        '& .MuiOutlinedInput-root': {
            borderColor: '#000'
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#000'
        },
        "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
            borderColor: "#000"
        },
        // "&:hover": {
        //     borderColor: "#000"
        // },
        '& .MuiSelect-iconOutlined': {
            color: '#000',
            borderColor: "#000"
        },
        '& .MuiFormControl-root': {
            borderWidth: 0,
            borderColor: "#000"
        },
        '& .Mui-disabled': {
            color: '#000',
            borderColor: '#000',
        }
    },
    refferalSignUpFormContainer: {
        pt: 3,
        paddingBottom: 2,
        pl: 2,
        pr: 2,
        display: 'flex',
        justifyContent: 'center',
        // alignItems: 'center',
        alignContent: 'center',
        width: '100%',
        maxWidth: 400,
        margin: '2px auto',
        minHeight: 500,
        overflow: 'hidden',
        boxShadow: '3px 3px 7px 1px #ccc',
        background: '#DAE5F1',
        borderRadius: '10px',
        '& h5': {
            fontWeight: 500,
        },
        // '& span': {
        //     color: '#fff',
        // },
        // '& .MuiDivider-root': {
        //     backgroundColor: '#f1f1f1'
        // },
        // '& .MuiInputBase-input': {
        //     color: '#fff'
        // },
        // '& .MuiFormLabel-root': {
        //     color: '#fff'
        // },
        // '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
        //     borderColor: '#fff'
        // },
        // "&:hover": {
        //     borderColor: "#fff"
        // },
        // '& .MuiSelect-iconOutlined': {
        //     color: '#fff'
        // },
        // '& .MuiFormControl-root': {
        //     borderWidth: 0,
        // },
        // '& .Mui-disabled': {
        //     color: '#fff',
        //     borderColor: '#fff',
        // }
    },
    newPartnerFormContainer: {
        padding: 1,
        display: 'flex',
        flexDirection: 'column',
        alignContent: 'center',
        width: '100%',
        maxWidth: 900,
        margin: '2px auto',
        minHeight: 600,
        overflow: 'hidden',
        boxShadow: '3px 3px 7px 1px #ccc',
        background: '#DAE5F1',
        borderRadius: '10px',
        '& h5': {
            fontWeight: 500,
        },
        '& span': {
            color: '#000',
        },
        '& .MuiDivider-root': {
            backgroundColor: '#f1f1f1'
        },
        '& .MuiInputBase-input': {
            color: '#000'
        },
        '& .MuiFormLabel-root': {
            color: '#000'
        },
        '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
            borderColor: '#000'
        },
        "&:hover": {
            borderColor: "#000"
        },
        '& .MuiSelect-iconOutlined': {
            color: '#000'
        },
        '& .MuiFormControl-root': {
            borderWidth: 0,
        },
        '& .Mui-disabled': {
            color: '#000',
            borderColor: '#000',
        }
    },

    collectionInfoLftContainer: {
        display: 'flex', flexDirection: 'column',
        pt: 2, minWidth: 400, alignItem: 'flex-start'
    } as const,

    collectionInfoRhtContainer: {
        display: 'flex', flexDirection: 'column',
        pt: 2, pl: 1,
        pr: 1,
    } as const,
    collectionInfoRhtContainer4: {
        display: 'flex',
        flexDirection: 'column',
        // pt: 2,
        // pl: 1,
        // pr: 1,
        //p:2,
        minWidth: 360,
    } as const,

    collectionInfo1: {
        display: 'flex', flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
    } as const,

    collectionInfo2:
        {
            display: 'flex',
            flexDirection: 'column',
            width: '48%',
        } as const,

    headerColor: {
        // bgcolor: '#002352',
        color: '#fff'
    } as const,

    securityCageContainer: {
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        // minWidth: 600,
        justifyContent: 'center',
        minHeight: 260,
        p: 1,
        // '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
        //     borderColor: '#fff'
        // },
        // "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
        //     borderColor: "#fff"
        // },

        // "&:hover": {
        //     borderColor: "#fff"
        // },
        // '& .MuiSelect-iconOutlined': {
        //     color: '#fff'
        // },
        // '& .MuiFormControl-root': {
        //     borderWidth: 0,
        // },
        // '& .Mui-disabled': {
        //     color: '#fff',
        //     borderColor: '#fff',
        // },
        // '& .MuiInputBase-root': {
        //     borderColor: '#fff',
        // }

    } as const,

    disableColorStyle: {
        marginTop: .2, width: '100%',

        "& .MuiInputBase-input.Mui-disabled": {
            WebkitTextFillColor: "#000",
            borderColor: "#000"
        },
        // "&:hover": {
        //     borderColor: "#fff"
        // },
        // '& .MuiSelect-iconOutlined': {
        //     color: '#fff',
        //     borderColor: "#fff"
        // },
        // '& .MuiFormControl-root': {
        //     borderWidth: 0,
        // },
        // '& .MuiInputBase-root': {
        //     borderColor: '#fff',
        // },
        // '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
        //     borderColor: '#fff'
        // },
    } as const,

    newSecurityCageContainer: {
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        // minWidth: 600,
        // justifyContent: 'center',
        minHeight: 260,
        p: 1,

    } as const,

    // securityCageContainerMobile: {
    //     display: 'flex',
    //     flexDirection: 'column',
    //     // flexWrap: 'wrap',
    //     // justifyContent: 'left',
    //     // border:6,
    //     alignItems: 'center',

    // } as const,

    style: {
        position: 'absolute' as 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 360,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 1,
    },
    formControlStyle: {
        pt: 2,
    },
    btn: {
        mt: 3,
        ml: 1, mb: 1,
        "&.Mui-disabled": {
            color: "#c0c0c0"
        }
        // bgcolor: '#234f1e',
        // '&:hover': {
        //     backgroundColor: '#234f1e',
        //     opacity: [0.9, 0.8, 0.7],
        // },
    },

    newBtn: {
        "&.Mui-disabled": {
            color: "#c0c0c0"
        }
    },
    chkBoxStyles: {
        // color: '#234f1e',
        // '&.Mui-checked': {
        //     color: '#234f1e',
        // },
        '& .MuiSvgIcon-root': {
            fontSize: 30
        },
        "&.Mui-disabled": {
            color: "#c0c0c0"
        }
    },

    partnerFormControls: {
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        // minWidth: 600,
        justifyContent: 'center',
        // minHeight: 260,
        p: 1,
        m: '0 auto',
        '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
            borderColor: '#000'
        },
        "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
            borderColor: "#000"
        },

        // "&:hover": {
        //     borderColor: "#000"
        // },
        // '& .MuiSelect-iconOutlined': {
        //     color: '#000'
        // },
        '& .MuiFormControl-root': {
            borderWidth: 0,
        },
        '& .Mui-disabled': {
            color: '#000',
            borderColor: '#000',
        },
        '& .MuiInputBase-root': {
            borderColor: '#000',
        }

    } as const,



}
// export const fieldStyle = (isMobile: boolean) => {
//     return {
//         maxWidth: !isMobile ? 200 : 80
//     }

// }

